export function verifyFilename(name) {
  // 名称不能为空
  if(!name){
    return {
      valid: false,
      msg: `名称不能为空`
    }
  }
  // 名称不能以.开头
  let regex2 = /^[^.].*$/;
  if(!regex2.test(name)){
    return {
      valid: false,
      msg: `名称不能以.开头`
    }
  }
  // 名称长度在1-100之间
  if(name.length > 100 || name.length < 1){
    return {
      valid: false,
      msg: `名称长度在1-100之间`
    }
  }
  // 名称不能包含/:*?<>|"
  let regex4 = /^[^\\/\\:\\*\\?\\<\\>\\|\\"]{1,100}$/;
  if(!regex4.test(name)){
    return {
      valid: false,
      msg: `名称中不能包含/:*?<>|"`
    }
  }
  // 通过验证
  return {
    valid: true,
    msg: "验证通过"
  }
}

export function verifyTagname(name) {

  // 标签长度在1-20之间
  if(name.length > 20 || name.length < 1){
    return {
      valid: false,
      msg: `标签 长度在1-20之间`
    }
  }

  // 标签不能包含~!@#$%^&*+{}:<>?[],./;’`=\
  let regex = /^[^\\/\\!\\@\\#\\$\\%\\^\\&\\*\\+\\{\\}\\:\\<\\>\\?\\[\\,\\.\\;\\’\\`\\=]{1,20}$/;
  if(!regex.test(name)){
    return {
      valid: false,
      msg: `标签 不能包含 ~ ! @ # $ % ^ & * + { } : < > ? [ ] , . / ; ’ \` = \\ `
    }
  }

  // 单独验证]
  let regex2 = /]/;
  if(regex2.test(name)){
    return {
      valid: false,
      msg: `标签2 不能包含 ~ ! @ # $ % ^ & * + { } : < > ? [ ] , . / ; ’ \` = \\ `
    }
  }
  
  // 通过验证
  return {
    valid: true,
    msg: "验证通过"
  }
}